import { Injectable } from '@angular/core';
import { State, Action, Selector, StateContext } from '@ngxs/store';
import {
  DataProtectionNoticeCountriesListLoad,
  DataProtectionNoticeCountriesListInitialState,
} from './data-protection-notice-countries-list.actions';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { NotificationService } from '../../../../../common/services';
import { CustomHttpErrorResponse, Error } from '../../../../../common/constants/error';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';
import { DataProtectionNoticeCountriesListService } from './data-protection-notice-countries-list.service';

export interface DpnCountriesListStateModel {
  countriesList: string[];
  loaded: boolean;
}

const initialState: DpnCountriesListStateModel = {
  countriesList: null,
  loaded: false,
};

@State<DpnCountriesListStateModel>({
  name: 'dataProtectionNoticeCountriesList',
  defaults: initialState,
})
@Injectable()
export class DataProtectionNoticeCountriesListState {
  constructor(
    private dpnListService: DataProtectionNoticeCountriesListService,
    private notificationService: NotificationService,
  ) {}

  @Selector()
  static getState(state: DpnCountriesListStateModel): DpnCountriesListStateModel {
    return state;
  }

  @Selector()
  static getItems(state: DpnCountriesListStateModel): string[] {
    return state.countriesList;
  }

  @Selector()
  static getLoaded(state: DpnCountriesListStateModel): boolean {
    return state.loaded;
  }

  @Action(DataProtectionNoticeCountriesListLoad)
  getDataProtectionNoticeCountriesList(
    ctx: StateContext<DpnCountriesListStateModel>,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.dpnListService.getDpnCountriesList().pipe(
      map((countriesList: string[]) => {
        ctx.patchState({ countriesList, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(DataProtectionNoticeCountriesListInitialState)
  setInitialState(ctx: StateContext<DpnCountriesListStateModel>): void {
    ctx.setState(initialState);
  }
}
